var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87786 1.56637C3.73235 1.71375 3.7331 1.95075 3.88011 2.09662L7.75723 5.93848L3.89662 9.83399C3.75076 9.98137 3.75187 10.2184 3.89888 10.3646C4.04626 10.5105 4.28363 10.5094 4.42952 10.3624L8.53239 6.22199C8.53876 6.21562 8.54027 6.20738 8.54626 6.20099C8.54775 6.1995 8.54963 6.19911 8.55114 6.19762C8.62351 6.12451 8.65989 6.02887 8.65989 5.93362C8.65989 5.83725 8.62276 5.7405 8.5489 5.66737L4.40853 1.56449C4.26111 1.41824 4.02374 1.41935 3.87786 1.56637Z",
    fill: "#666666"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0bbc6a6e0e7e80885433e2bdaff428a8.svg";
export { ForwardRef as ReactComponent };